import React from 'react';
import {
  IDayConfig,
  IBreakConfig,
} from '../interfaces/schedule-period.interface';
import { TimeRangePicker, Switcher, DefaultButton } from 'shared/ui';
import { BreakInput } from './break-input';
import styles from './settings.module.scss';

interface IDayConfigRowProps {
  label: string;
  value: IDayConfig;
  onChange: (value: IDayConfig) => void;
}

export const DayConfigRow: React.FC<IDayConfigRowProps> = ({
  label,
  value,
  onChange,
}) => {
  return (
    <div className={styles.day_row}>
      <div className={styles.day_row__label}>{label}</div>

      {value.isDayOff ? (
        <div className={styles.day_row__controls_off}>
          <span className={styles.day_row__day_off_text}>Выходной</span>
        </div>
      ) : (
        <div className={styles.day_row__controls}>
          <TimeRangePicker
            key={`${value.startedAt}-${value.finishedAt}`}
            timeRange={{ start: value.startedAt, end: value.finishedAt }}
            onChange={(data) =>
              onChange({
                ...value,
                startedAt: data.timeRange.start,
                finishedAt: data.timeRange.end,
              })
            }
            index={0}
          />

          <div className={styles.day_row__breaks}>
            {value.breaks.map((br, i) => (
              <BreakInput
                key={i}
                value={br}
                onChange={(newBr) => {
                  const breaks = [...value.breaks];
                  breaks[i] = newBr;
                  onChange({ ...value, breaks });
                }}
                onDelete={() => {
                  const breaks = value.breaks.filter((_, idx) => idx !== i);
                  onChange({ ...value, breaks });
                }}
              />
            ))}
            <DefaultButton
              buttonText="Добавить перерыв"
              color="green"
              className={styles.day_row__add_break}
              onClick={() => {
                const newBreak: IBreakConfig = {
                  title: 'Перерыв',
                  start: '13:00',
                  end: '13:30',
                };
                onChange({ ...value, breaks: [...value.breaks, newBreak] });
              }}
            />
          </div>
        </div>
      )}

      <div className={styles.day_row__switcher}>
        <Switcher
          isActive={!value.isDayOff}
          onClick={() => {
            if (value.isDayOff) {
              onChange({
                ...value,
                isDayOff: false,
                startedAt: '09:00',
                finishedAt: '18:00',
              });
            } else {
              onChange({
                ...value,
                isDayOff: true,
                startedAt: null,
                finishedAt: null,
              });
            }
          }}
        />
      </div>
    </div>
  );
};
